import { request } from "../../../apis";
import { getCurrency } from "../../../plugins/utils";
const CURRENCY = getCurrency();

export const getAgentFeeBonus = ({ params }) =>
  request("get", `/${CURRENCY}/agent/fee/bonus/`, { ...params }, true, false);

export const getAgentFeeBetBonus = ({ params, page }) =>
  request("get", `/${CURRENCY}/agent/fee/bonus/bet`, { ...params, page }, true, false);

export const getAgentFeeLevelBonus = ({ params, page }) =>
  request("get", `/${CURRENCY}/agent/fee/bonus/detail`, { ...params, page }, true, false);
